// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles-module__avatar___3-Gg_","avatars":"styles-module__avatars___3_gyT"};